import { SocketServiceEnum, type SocketConfig } from "./types";

export const socketConfigs: SocketConfig = {
  [SocketServiceEnum.ROOT_BACKEND_SERVICE]: {
    host: process.env.NEXT_PUBLIC_WS_BASE_URL as string,
  },
};
